import type { UserSessionData } from '@generated/search-bff';
import type { initSnowplowTracker } from '@ev-tech/snowplow-library';

type SnowplowTrackerInitializer = ({ hasUserAcceptedAgreement }: { hasUserAcceptedAgreement: boolean }) => void;

type SnowplowTracker = NonNullable<ReturnType<typeof initSnowplowTracker>>;

export type SnowplowWindow = {
  initSnowplowTracker?: SnowplowTrackerInitializer;
  trackingEnabled?: boolean;
  tracker?: SnowplowTracker;
};

export const getSnowplowWindow = (): SnowplowWindow & Record<string, unknown> => (window.evSnowplow ??= {});

export const enableSnowplowTracking = (): void => {
  getSnowplowWindow().trackingEnabled = true;
};

export const setSnowplowTracker = (tracker: SnowplowTracker | null | undefined): void => {
  if (!tracker) {
    return;
  }

  getSnowplowWindow().tracker = tracker;
};

export const getSnowplowPageViewId = (): string | undefined => getSnowplowWindow().tracker?.getPageViewId?.();

const getNetworkUserIdFromCookie = (): string | undefined => {
  const match = document?.cookie?.match(/(?:^|;\s*)sp=([^;]*)/);
  return match?.[1] ? decodeURIComponent(match[1]) : undefined;
};

export const getSnowplowUserSessionData = (): UserSessionData | undefined => {
  const tracker = getSnowplowWindow().tracker;
  const domainUserId = tracker?.getDomainUserId?.();
  const domainSessionIndex = tracker?.getDomainSessionIndex?.();
  const networkUserId = getNetworkUserIdFromCookie();

  return {
    domainUserId: domainUserId ?? undefined,
    domainSessionIndex: domainSessionIndex != null ? String(domainSessionIndex) : undefined,
    networkUserId: networkUserId ?? undefined,
  };
};
